import { useTranslation } from 'react-i18next';

export const useGetAgreementOption = (): {
    key: string;
    label: string;
}[] => {
    const { t } = useTranslation();
    return [
        {
            key: 'agreement',
            label: t('contactForm.agreementToProcessPD'),
        },
    ];
};
